module.exports = __webpack_public_path__ + "static/icon_karte-362e226e15f901c92b4afdab0dffc0be.png";